export function WaysSignUpIcon() {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="76" height="76" rx="38" fill="url(#paint0_linear_1693_68843)" />
            <path d="M51.5417 30.6666L51.5417 41.0833" stroke="#AD7122" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M56.7499 35.875L46.3333 35.875" stroke="#AD7122" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.5001 30.6667C26.5001 26.6166 29.7833 23.3334 33.8334 23.3334C37.8835 23.3334 41.1667 26.6166 41.1667 30.6667C41.1667 34.71 37.8945 37.9891 33.8537 38C33.8469 38 33.8402 38 33.8334 38C33.8267 38 33.8199 38 33.8131 38C29.7724 37.9891 26.5001 34.71 26.5001 30.6667ZM29.2218 38.783C26.4017 37.1772 24.5001 34.144 24.5001 30.6667C24.5001 25.512 28.6788 21.3334 33.8334 21.3334C38.9881 21.3334 43.1667 25.512 43.1667 30.6667C43.1667 34.144 41.2651 37.1772 38.445 38.783C43.9861 40.7217 48.1467 46.0593 49.1706 52.5211C49.543 54.8719 47.5746 56.6667 45.4167 56.6667H22.2501C20.0922 56.6667 18.1238 54.8719 18.4963 52.5211C19.5201 46.0593 23.6808 40.7217 29.2218 38.783ZM33.8123 40C27.2539 40.0116 21.6429 45.4414 20.4716 52.8341C20.3255 53.7562 21.0942 54.6667 22.2501 54.6667H45.4167C46.5726 54.6667 47.3413 53.7562 47.1952 52.8341C46.0239 45.4414 40.413 40.0116 33.8545 40C33.8475 40 33.8404 40 33.8334 40C33.8264 40 33.8194 40 33.8123 40Z"
                fill="#AD7122"
            />
            <defs>
                <linearGradient id="paint0_linear_1693_68843" x1="38" y1="0" x2="38" y2="76" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F7E7C1" />
                    <stop offset="1" stopColor="#EFBB74" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function WaysEarnIcon() {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="76" height="76" rx="38" fill="url(#paint0_linear_1693_69237)" />
            <path d="M21 26L37.4857 40L55 26" stroke="#AD7122" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <rect x="19" y="24" width="38" height="28" rx="3" stroke="#AD7122" strokeWidth="2" />
            <defs>
                <linearGradient id="paint0_linear_1693_69237" x1="38" y1="0" x2="38" y2="76" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F7E7C1" />
                    <stop offset="1" stopColor="#EFBB74" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function WaysRedeemIcon() {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="76" height="76" rx="38" fill="url(#paint0_linear_1693_68736)" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.6584 27.9055H52.6184C54.1177 27.9055 55.3332 29.121 55.3332 30.6203C55.3332 30.8769 55.2968 31.1322 55.2251 31.3786L50.8815 46.3097C50.5443 47.4689 49.4821 48.2662 48.2748 48.2662H31.6191C30.4118 48.2662 29.3496 47.4689 29.0124 46.3097L23.6584 27.9055Z"
                stroke="#AD7122"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M24.4775 30.6203L22.9551 25.7397C22.6013 24.6057 21.5514 23.8334 20.3635 23.8334H16.3333"
                stroke="#AD7122"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M31.5 57C32.8807 57 34 55.8807 34 54.5C34 53.1193 32.8807 52 31.5 52C30.1193 52 29 53.1193 29 54.5C29 55.8807 30.1193 57 31.5 57Z"
                fill="#AD7122"
            />
            <path
                d="M48.5 57C49.8807 57 51 55.8807 51 54.5C51 53.1193 49.8807 52 48.5 52C47.1193 52 46 53.1193 46 54.5C46 55.8807 47.1193 57 48.5 57Z"
                fill="#AD7122"
            />
            <path d="M34.5176 34.7173V41.5094" stroke="#AD7122" strokeWidth="2" strokeLinecap="round" />
            <path d="M39.947 34.7173V41.5094" stroke="#AD7122" strokeWidth="2" strokeLinecap="round" />
            <path d="M45.3765 34.7173V41.5094" stroke="#AD7122" strokeWidth="2" strokeLinecap="round" />
            <defs>
                <linearGradient id="paint0_linear_1693_68736" x1="38" y1="0" x2="38" y2="76" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F7E7C1" />
                    <stop offset="1" stopColor="#EFBB74" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function WaysWarrantyIcon() {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="76" height="76" rx="38" fill="url(#paint0_linear_1693_66954)" />
            <path
                d="M50.5118 47.2027C51.2264 45.4805 51.6209 43.5946 51.6209 41.6177V25.2051L36.6246 20.375L21.6293 25.2051V41.6177C21.5332 54.3529 37.2679 61.0655 46.635 52.6148"
                stroke="url(#paint1_linear_1693_66954)"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M50.5118 47.2027C51.2264 45.4805 51.6209 43.5946 51.6209 41.6177V25.2051L36.6246 20.375L21.6293 25.2051V41.6177C21.5332 54.3529 37.2679 61.0655 46.635 52.6148"
                stroke="#AD7122"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M40.789 31.3127C38.3668 28.8772 34.7304 28.4113 31.8407 29.9109L34.891 32.9778L31.587 36.2997L28.5367 33.2328C27.0453 36.1372 27.5097 39.7945 29.9309 42.2299C32.2079 44.5183 35.5569 45.0654 38.3504 43.8775L47.9821 53.5627C49.1083 54.695 50.9342 54.694 52.0604 53.5627C53.1866 52.4303 53.1866 50.5945 52.0604 49.4621L42.4287 39.778C43.6092 36.9693 43.066 33.602 40.789 31.3127Z"
                stroke="url(#paint2_linear_1693_66954)"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M40.789 31.3127C38.3668 28.8772 34.7304 28.4113 31.8407 29.9109L34.891 32.9778L31.587 36.2997L28.5367 33.2328C27.0453 36.1372 27.5097 39.7945 29.9309 42.2299C32.2079 44.5183 35.5569 45.0654 38.3504 43.8775L47.9821 53.5627C49.1083 54.695 50.9342 54.694 52.0604 53.5627C53.1866 52.4303 53.1866 50.5945 52.0604 49.4621L42.4287 39.778C43.6092 36.9693 43.066 33.602 40.789 31.3127Z"
                stroke="#AD7122"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <defs>
                <linearGradient id="paint0_linear_1693_66954" x1="38" y1="0" x2="38" y2="76" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F7E7C1" />
                    <stop offset="1" stopColor="#EFBB74" />
                </linearGradient>
                <linearGradient id="paint1_linear_1693_66954" x1="36.6249" y1="20.375" x2="36.6249" y2="56.375" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FCDA98" />
                    <stop offset="1" stopColor="#CF9D5B" />
                </linearGradient>
                <linearGradient id="paint2_linear_1693_66954" x1="40.2944" y1="29.053" x2="40.2944" y2="54.4115" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F2CD8B" />
                    <stop offset="1" stopColor="#D09E5C" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function WaysProfileIcon() {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="76" height="76" rx="38" fill="url(#paint0_linear_1693_68793)" />
            <path
                d="M37 25H23C21.3431 25 20 26.3431 20 28V50C20 51.6569 21.3431 53 23 53H53C54.6569 53 56 51.6569 56 50V48"
                stroke="#AD7122"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M46.0498 37C49.3635 37 52.0498 34.3137 52.0498 31C52.0498 27.6863 49.3635 25 46.0498 25C42.7361 25 40.0498 27.6863 40.0498 31C40.0498 34.3137 42.7361 37 46.0498 37Z"
                stroke="#AD7122"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M56.0498 43.4187C54.0966 39.6023 50.0497 37 46.0497 37C42.0497 37 40.0569 38.1329 38 40"
                stroke="#AD7122"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M28 35H34" stroke="#AD7122" strokeWidth="2" strokeLinecap="round" />
            <path d="M28 45H48" stroke="#AD7122" strokeWidth="2" strokeLinecap="round" />
            <defs>
                <linearGradient id="paint0_linear_1693_68793" x1="38" y1="0" x2="38" y2="76" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F7E7C1" />
                    <stop offset="1" stopColor="#EFBB74" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function ReferralIcon() {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="76" height="76" rx="38" fill="url(#paint0_linear_1693_68639)" />
            <path
                d="M51.2897 43.5519L39.1763 55.6652C38.3037 56.5378 36.8889 56.5378 36.0163 55.6652L21.2696 40.9185C17.4883 37.1372 17.4883 31.0065 21.2696 27.2251C25.0509 23.4438 31.1816 23.4438 34.9629 27.2251L37.5837 29.8459"
                stroke="#AD7122"
                strokeWidth="2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M53.9444 27.4079C57.6249 31.0884 57.6842 37.0187 54.1225 40.7717L53.871 41.0271L51.2892 43.5539L45.2304 37.4951C44.9403 37.2051 44.4704 37.2041 44.1792 37.493L41.3877 40.2622C39.553 42.0823 36.592 42.0764 34.7646 40.249L34.5145 39.9989C32.6121 38.0964 32.5678 35.0394 34.3818 33.0832L34.5428 32.9174L40.1966 27.353C44.0169 23.5933 50.1543 23.6178 53.9444 27.4079Z"
                stroke="#AD7122"
                strokeWidth="2"
            />
            <path
                d="M30.8021 30.4367C29.0569 28.6915 26.2273 28.6915 24.4821 30.4367C22.7369 32.182 22.7369 35.0115 24.4821 36.7568"
                stroke="#AD7122"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <defs>
                <linearGradient id="paint0_linear_1693_68639" x1="38" y1="0" x2="38" y2="76" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F7E7C1" />
                    <stop offset="1" stopColor="#EFBB74" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function RightIns() {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="76" height="76" rx="38" fill="url(#paint0_linear_1693_67017)" />
            <path
                d="M47.7111 20.52H28.2889C23.9983 20.52 20.52 23.9983 20.52 28.2889V47.7111C20.52 52.0018 23.9983 55.48 28.2889 55.48H47.7111C52.0018 55.48 55.48 52.0018 55.48 47.7111V28.2889C55.48 23.9983 52.0018 20.52 47.7111 20.52Z"
                stroke="#AD7122"
                strokeWidth="2"
                strokeLinejoin="round"
            />
            <path
                d="M38 46.28C42.5729 46.28 46.28 42.5729 46.28 38C46.28 33.427 42.5729 29.72 38 29.72C33.427 29.72 29.72 33.427 29.72 38C29.72 42.5729 33.427 46.28 38 46.28Z"
                stroke="#AD7122"
                strokeWidth="2"
                strokeLinejoin="round"
            />
            <path
                d="M48.5417 29.375C49.6002 29.375 50.4583 28.5169 50.4583 27.4583C50.4583 26.3997 49.6002 25.5416 48.5417 25.5416C47.4831 25.5416 46.625 26.3997 46.625 27.4583C46.625 28.5169 47.4831 29.375 48.5417 29.375Z"
                fill="#AD7122"
            />
            <defs>
                <linearGradient id="paint0_linear_1693_67017" x1="38" y1="0" x2="38" y2="76" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F7E7C1" />
                    <stop offset="1" stopColor="#EFBB74" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function RightX() {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="76" height="76" rx="38" fill="url(#paint0_linear_1693_66960)" />
            <path
                d="M41.048 35.5512L52.962 22H50.1391L39.7895 33.7639L31.5293 22H22L34.4938 39.7907L22 54H24.8229L35.7456 41.574L44.4707 54H54L41.048 35.5512ZM37.1804 39.9469L35.9126 38.1742L25.8409 24.0823H30.1773L38.3079 35.4591L39.5704 37.2318L50.1378 52.0191H45.8013L37.1804 39.9469Z"
                fill="#AD7122"
            />
            <defs>
                <linearGradient id="paint0_linear_1693_66960" x1="38" y1="0" x2="38" y2="76" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F7E7C1" />
                    <stop offset="1" stopColor="#EFBB74" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function RightYoutube() {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="76" height="76" rx="38" fill="url(#paint0_linear_1693_67034)" />
            <path
                d="M24.3849 23.444C30.2199 23.148 34.7582 23 38 23C41.2422 23 45.7822 23.1481 51.62 23.4441C54.7801 23.6044 57.336 26.1199 57.5996 29.3291C57.8665 32.5799 58 35.4429 58 37.9184C58 40.4242 57.8633 43.3271 57.5897 46.6274C57.3269 49.7967 54.8266 52.2941 51.7084 52.5017C46.7175 52.8339 42.148 53 38 53C33.8526 53 29.2848 52.8339 24.2966 52.5019C21.1794 52.2944 18.6796 49.7985 18.4156 46.6304C18.1385 43.3055 18 40.4015 18 37.9184C18 35.4651 18.1352 32.6011 18.4057 29.3261C18.6706 26.1182 21.226 23.6043 24.3849 23.444Z"
                stroke="#AD7122"
                strokeWidth="2"
                strokeLinejoin="round"
            />
            <path
                d="M35 32.9787V43.0215C35 43.562 35.4156 44 35.928 44C36.1101 44 36.2881 43.9436 36.4399 43.8379L43.5836 38.8596C44.0112 38.5617 44.1287 37.9545 43.8461 37.5037C43.7785 37.3959 43.6913 37.3033 43.5897 37.2312L36.4459 32.1666C36.0206 31.865 35.4439 31.9842 35.1579 32.4326C35.055 32.5941 35 32.7841 35 32.9787Z"
                fill="#AD7122"
            />
            <defs>
                <linearGradient id="paint0_linear_1693_67034" x1="38" y1="0" x2="38" y2="76" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F7E7C1" />
                    <stop offset="1" stopColor="#EFBB74" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function RightFacebook() {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="76" height="76" rx="38" fill="url(#paint0_linear_1693_67005)" />
            <path
                d="M30.2154 19.5666L30.6109 20.4851L30.6109 20.4851L30.2154 19.5666ZM23.874 23.8393L23.1665 23.1325L23.1665 23.1325L23.874 23.8393ZM19.5854 30.1872L18.6685 29.7881H18.6685L19.5854 30.1872ZM19.5854 45.7721L20.5023 45.373L19.5854 45.7721ZM30.2154 56.413L30.6153 55.4964H30.6153L30.2154 56.413ZM45.7845 56.413L46.1844 57.3296L45.7845 56.413ZM52.126 52.12L52.8335 52.8268H52.8335L52.126 52.12ZM56.4146 45.7721L55.4977 45.373L56.4146 45.7721ZM52.126 23.8393L52.8335 23.1325L52.8335 23.1325L52.126 23.8393ZM45.7845 19.5666L45.3891 20.4851L45.3891 20.4851L45.7845 19.5666ZM38 17C35.1062 17 32.3762 17.5474 29.8199 18.6482L30.6109 20.4851C32.9057 19.497 35.3653 19 38 19V17ZM29.82 18.6482C27.2822 19.7409 25.0615 21.2356 23.1665 23.1325L24.5814 24.546C26.2908 22.8349 28.2977 21.4812 30.6109 20.4851L29.82 18.6482ZM23.1665 23.1325C21.2725 25.0285 19.7734 27.2499 18.6685 29.7881L20.5023 30.5863C21.5112 28.2686 22.8711 26.2581 24.5815 24.546L23.1665 23.1325ZM18.6685 29.7881C17.5543 32.3476 17 35.0816 17 37.9797H19C19 35.3436 19.5026 32.8827 20.5023 30.5863L18.6685 29.7881ZM17 37.9797C17 40.8778 17.5543 43.6117 18.6685 46.1713L20.5023 45.373C19.5026 43.0766 19 40.6157 19 37.9797H17ZM18.6685 46.1713C19.7734 48.7095 21.2725 50.9309 23.1665 52.8268L24.5814 51.4133C22.8711 49.7012 21.5112 47.6907 20.5023 45.373L18.6685 46.1713ZM23.1665 52.8268C25.0605 54.7227 27.2798 56.2235 29.8156 57.3296L30.6153 55.4964C28.3002 54.4866 26.2918 53.1254 24.5814 51.4133L23.1665 52.8268ZM29.8156 57.3296C32.3729 58.4451 35.1044 59 38 59V57C35.3671 57 32.909 56.497 30.6153 55.4964L29.8156 57.3296ZM38 59C40.8956 59 43.6271 58.4451 46.1844 57.3296L45.3847 55.4964C43.091 56.497 40.6329 57 38 57V59ZM46.1844 57.3296C48.7202 56.2235 50.9395 54.7227 52.8335 52.8268L51.4186 51.4133C49.7082 53.1254 47.6998 54.4866 45.3847 55.4964L46.1844 57.3296ZM52.8335 52.8268C54.7275 50.9309 56.2266 48.7095 57.3315 46.1713L55.4977 45.373C54.4888 47.6907 53.1289 49.7012 51.4186 51.4133L52.8335 52.8268ZM57.3315 46.1713C58.4457 43.6117 59 40.8778 59 37.9797H57C57 40.6157 56.4974 43.0766 55.4977 45.373L57.3315 46.1713ZM59 37.9797C59 35.0816 58.4457 32.3476 57.3315 29.7881L55.4977 30.5863C56.4974 32.8827 57 35.3436 57 37.9797H59ZM57.3315 29.7881C56.2266 27.2499 54.7275 25.0285 52.8335 23.1325L51.4186 24.546C53.1289 26.2581 54.4888 28.2686 55.4977 30.5863L57.3315 29.7881ZM52.8335 23.1325C50.9385 21.2356 48.7178 19.7409 46.18 18.6482L45.3891 20.4851C47.7023 21.4812 49.7092 22.8349 51.4186 24.546L52.8335 23.1325ZM46.18 18.6482C43.6238 17.5474 40.8938 17 38 17V19C40.6347 19 43.0943 19.497 45.3891 20.4851L46.18 18.6482Z"
                fill="#AD7122"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M43 31.4764H39.8876C39.6886 31.4764 39.5039 31.5908 39.3333 31.8198C39.1628 32.0486 39.0775 32.3205 39.0775 32.6352V34.9528H43L42.4457 38.2146H39.0775V48H35.3682V38.2146H32V34.9528H35.3682V33.0215C35.3682 31.6481 35.7946 30.4678 36.6473 29.4807C37.5 28.4936 38.5801 28 39.8876 28H43V31.4764Z"
                fill="#AD7122"
            />
            <defs>
                <linearGradient id="paint0_linear_1693_67005" x1="38" y1="0" x2="38" y2="76" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F7E7C1" />
                    <stop offset="1" stopColor="#EFBB74" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function RightFollow() {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="76" height="76" rx="38" fill="url(#paint0_linear_1764_4912)" />
            <path
                d="M52.3588 45.3487L52.3508 45.3574L52.343 45.3664C50.4139 47.584 47.2442 50.097 44.2528 52.1849C41.2493 54.2813 38.5633 55.8541 37.6397 56.2395L37.6377 56.2403C37.5184 56.2904 37.4153 56.3286 37.3269 56.3574C37.3305 56.3345 37.3345 56.3092 37.3379 56.2863L37.5995 54.6631L37.602 54.6479L37.6039 54.6326C37.6386 54.3659 37.6773 54.0057 37.6779 53.6344C37.6784 53.2808 37.6459 52.8239 37.4794 52.4075L37.478 52.4041C37.2283 51.7864 36.6791 51.4421 36.2941 51.2565C35.8749 51.0543 35.4192 50.9308 35.0671 50.8571L35.0308 50.8495L34.994 50.8446C26.1157 49.6658 19.8333 43.5227 19.8333 36.4892C19.8333 28.6491 27.7807 21.9297 37.9999 21.9297C48.2172 21.9297 56.1666 28.6491 56.1666 36.4892C56.1666 39.6192 54.9766 42.4793 52.3588 45.3487Z"
                stroke="#AD7122"
                strokeWidth="2"
            />
            <path
                d="M32.1866 41.7285C32.3633 41.5527 32.4638 41.313 32.4661 41.0622L32.4661 40.8745C32.4639 40.6236 32.3633 40.3839 32.1865 40.208C32.0097 40.0322 31.7712 39.9346 31.5233 39.9367H29.0731V33.9378C29.0721 33.8136 29.0469 33.6908 28.9989 33.5765C28.951 33.4621 28.8813 33.3584 28.7938 33.2714C28.7063 33.1843 28.6027 33.1155 28.489 33.0689C28.3752 33.0224 28.2535 32.999 28.1308 33H27.9423C27.8196 32.999 27.6979 33.0224 27.5841 33.0689C27.4704 33.1155 27.3668 33.1843 27.2793 33.2714C27.1918 33.3584 27.1221 33.4621 27.0742 33.5765C27.0262 33.6908 27.001 33.8136 27 33.9379V40.8745C27 41.8021 27.7537 42 28.3194 42H31.5238C31.7716 42.002 32.01 41.9043 32.1866 41.7285Z"
                fill="#AD7122"
            />
            <path
                d="M34.8319 41.5494C35.0084 41.3707 35.1076 41.1283 35.1076 40.8756V34.1368C35.1076 33.8841 35.0084 33.6417 34.8319 33.463C34.6554 33.2843 34.416 33.1839 34.1663 33.1839C33.9167 33.1839 33.6773 33.2843 33.5008 33.463C33.3243 33.6417 33.2251 33.8841 33.2251 34.1368V40.8756C33.2251 41.1283 33.3243 41.3707 33.5008 41.5494C33.6773 41.7281 33.9167 41.8285 34.1663 41.8285C34.416 41.8285 34.6554 41.7281 34.8319 41.5494Z"
                fill="#AD7122"
            />
            <path
                d="M43.0924 41.5151C43.2642 41.3441 43.3722 41.1181 43.3979 40.8756L43.4005 40.8745V34.125C43.3944 33.876 43.2925 33.6392 43.1164 33.4653C42.9403 33.2913 42.704 33.194 42.458 33.194C42.2119 33.194 41.9756 33.2913 41.7995 33.4653C41.6234 33.6392 41.5215 33.876 41.5154 34.125V38.2472C41.5154 38.2472 38.7268 34.311 38.4347 33.8744C38.3383 33.6699 38.187 33.4971 37.9981 33.3757C37.8092 33.2542 37.5903 33.1891 37.3665 33.1877C37.2439 33.1866 37.1223 33.21 37.0086 33.2565C36.8949 33.3031 36.7914 33.3718 36.7039 33.4588C36.6165 33.5459 36.5468 33.6495 36.4989 33.7638C36.451 33.8781 36.4258 34.0008 36.4248 34.125V40.8745C36.4307 41.1235 36.5325 41.3603 36.7085 41.5343C36.8846 41.7082 37.1208 41.8056 37.3668 41.8056C37.6128 41.8056 37.8491 41.7082 38.0251 41.5343C38.2011 41.3603 38.3029 41.1235 38.3088 40.8745V36.9647L41.3449 41.2756C41.4524 41.4705 41.617 41.6268 41.8159 41.7231C42.0148 41.8194 42.2383 41.851 42.4556 41.8134C42.6955 41.7915 42.9206 41.6861 43.0924 41.5151Z"
                fill="#AD7122"
            />
            <path
                d="M49.4065 36.6349C49.2941 36.5878 49.1737 36.5636 49.052 36.5636L46.6018 36.5641V35.0638H49.052C49.1755 35.0668 49.2982 35.0447 49.4131 34.9989C49.528 34.9531 49.6327 34.8845 49.721 34.7971C49.8093 34.7098 49.8795 34.6054 49.9274 34.4902C49.9753 34.375 50 34.2513 50 34.1263C50 34.0013 49.9753 33.8776 49.9274 33.7624C49.8795 33.6472 49.8093 33.5428 49.721 33.4555C49.6327 33.3681 49.528 33.2995 49.4131 33.2537C49.2982 33.2079 49.1755 33.1858 49.052 33.1888H45.377C45.2664 33.1875 45.1566 33.2083 45.054 33.2501C44.9514 33.2918 44.858 33.3536 44.779 33.432C44.7001 33.5104 44.6372 33.6038 44.5939 33.7068C44.5507 33.8099 44.528 33.9205 44.5271 34.0325V40.9708C44.528 41.0827 44.5508 41.1933 44.5941 41.2962C44.6373 41.3992 44.7002 41.4925 44.7792 41.5709C44.8581 41.6492 44.9516 41.711 45.0541 41.7527C45.1567 41.7944 45.2664 41.8152 45.3769 41.8139H49.052C49.1754 41.8168 49.2982 41.7948 49.4131 41.749C49.528 41.7032 49.6326 41.6346 49.721 41.5472C49.8093 41.4599 49.8795 41.3555 49.9274 41.2403C49.9753 41.1251 50 41.0014 50 40.8764C50 40.7514 49.9753 40.6277 49.9274 40.5125C49.8795 40.3973 49.8093 40.2929 49.721 40.2056C49.6326 40.1182 49.528 40.0496 49.4131 40.0038C49.2982 39.958 49.1754 39.9359 49.052 39.9389H46.6018V38.4391H49.052C49.1737 38.4391 49.2941 38.4149 49.4065 38.3677C49.5189 38.3206 49.621 38.2515 49.707 38.1645C49.793 38.0774 49.8613 37.974 49.9078 37.8602C49.9544 37.7464 49.9783 37.6245 49.9783 37.5013C49.9783 37.3782 49.9544 37.2562 49.9078 37.1425C49.8613 37.0287 49.793 36.9253 49.707 36.8382C49.621 36.7512 49.5189 36.6821 49.4065 36.6349Z"
                fill="#AD7122"
            />
            <defs>
                <linearGradient id="paint0_linear_1764_4912" x1="38" y1="0" x2="38" y2="76" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F7E7C1" />
                    <stop offset="1" stopColor="#EFBB74" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function RightKakoo() {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="76" height="76" rx="38" fill="url(#paint0_linear_1768_4926)" />
            <path
                d="M37.5089 21C27.2934 21 19 27.691 19 35.95C19 41.2919 22.4704 45.9775 27.6671 48.6211C27.3824 49.6238 25.8518 55.0569 25.7807 55.4944C25.7807 55.4944 25.7451 55.8226 25.9408 55.932C26.1366 56.0596 26.3858 55.9685 26.3858 55.9685C26.9731 55.8773 33.1308 51.447 34.1986 50.6813C35.2665 50.8271 36.3699 50.9183 37.4911 50.9183C47.7066 50.9183 56 44.2272 56 35.9682C56.0178 27.691 47.7244 21 37.5089 21Z"
                stroke="#AD7122"
                strokeWidth="2"
            />
            <path
                d="M28.3873 40.4602C27.8625 40.4602 27.4331 40.0468 27.4331 39.5538V33.8765H25.9383C25.4294 33.8765 25 33.463 25 32.9383C25 32.4294 25.4135 32 25.9383 32H30.8204C31.3293 32 31.7587 32.4135 31.7587 32.9383C31.7587 33.4471 31.3452 33.8765 30.8204 33.8765H29.3255V39.5379C29.3414 40.0627 28.9121 40.4602 28.3873 40.4602Z"
                fill="#AD7122"
            />
            <path
                d="M36.7519 40.4442C36.3543 40.4442 36.0522 40.2852 35.9568 40.0148L35.4797 38.7744H32.5695L32.0924 40.0148C31.997 40.2693 31.6948 40.4283 31.2973 40.4283C31.0905 40.4283 30.8838 40.3806 30.693 40.3011C30.4226 40.1738 30.1841 39.8399 30.4703 38.9493L32.7603 32.954C32.9193 32.4928 33.4123 32.0316 34.0325 32.0157C34.6527 32.0316 35.1457 32.4928 35.3047 32.954L37.5788 38.9652C37.8651 39.8717 37.6106 40.2056 37.3562 40.317C37.1813 40.4124 36.9586 40.4442 36.7519 40.4442ZM34.9867 37.1046L34.0325 34.4012L33.0784 37.1046H34.9867Z"
                fill="#AD7122"
            />
            <path
                d="M39.1216 40.3329C38.6127 40.3329 38.1992 39.9353 38.1992 39.4582V32.9699C38.1992 32.4451 38.6286 32.0157 39.1693 32.0157C39.71 32.0157 40.1394 32.4451 40.1394 32.9699V38.5677H42.1749C42.6838 38.5677 43.0973 38.9652 43.0973 39.4423C43.0973 39.9194 42.6838 40.317 42.1749 40.317H39.1216V40.3329Z"
                fill="#AD7122"
            />
            <path
                d="M44.4173 40.4442C43.8925 40.4442 43.4631 40.0148 43.4631 39.49V32.9699C43.4631 32.4451 43.8925 32.0157 44.4173 32.0157C44.9421 32.0157 45.3715 32.4451 45.3715 32.9699V35.0214L48.0272 32.3656C48.1703 32.2225 48.3453 32.1589 48.552 32.1589C48.7905 32.1589 49.0291 32.2543 49.204 32.4451C49.3789 32.6201 49.4744 32.8268 49.4903 33.0494C49.5062 33.2721 49.4267 33.4788 49.2835 33.6378L47.1049 35.8165L49.4585 38.9334C49.6175 39.1402 49.6811 39.3946 49.6493 39.6332C49.6175 39.8876 49.4903 40.1102 49.2835 40.2693C49.1245 40.3965 48.9178 40.4601 48.711 40.4601C48.4089 40.4601 48.1385 40.317 47.9477 40.0784L45.7054 37.1205L45.3715 37.4545V39.5377C45.3715 40.0307 44.9421 40.4442 44.4173 40.4442Z"
                fill="#AD7122"
            />
            <defs>
                <linearGradient id="paint0_linear_1768_4926" x1="38" y1="0" x2="38" y2="76" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F7E7C1" />
                    <stop offset="1" stopColor="#EFBB74" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function RightIcon() {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="76" height="76" rx="38" fill="white" />
            <path d="M51.8549 30.875L34.4383 48.2917L25.5312 39.7813" stroke="#30BF00" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
